/**
 * The supplier portal client every hook imports: every supplier screen, and
 * the Habits team's view of them, on the api-server at `VITE_API_SERVER_URL`.
 */
import type { SupplierPortalApi } from "./supplierPortal.contract.ts";
import { supplierPortalReal } from "./supplierPortal.real.ts";

export const supplierPortalApi: SupplierPortalApi = supplierPortalReal;
